import { LabelRequestType } from './LabelPrinterType';

export const LabelRequestDummy: LabelRequestType = {
	message: {
		labelType: 'NORMAL',
		labelId: '0731004717',
		labelName: '플레이존',
		timeEnter: new Date(),
		timeExit: new Date(),
		timeUse: '2시간권',
	},
	deviceNum: 'LabelPrinter1',
	deviceType: 'POS',
	modelName: 'BXLN_SLP_DX420',
	newDdizi: false,
};

// 갭 라벨지 샘플 출력용 고객 정보
export const LabelRequestGapLabelMetaDummy: LabelRequestType['meta'] = {
	고객명: '홍길동',
	생년월일: '2019-03-15',
	성별: 'MALE',
	권종: '키즈',
};
